module.exports = require('./lib/ArrowKeysReact');
